(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
/**
 * @name jQuery Stick 'em
 * @author Trevor Davis
 * @version 1.4.1
 *
 *  $('.container').stickem({
 *    item: '.stickem',
 *    container: '.stickem-container',
 *    stickClass: 'stickit',
 *    endStickClass: 'stickit-end',
 *    offset: 0,
 *    onStick: null,
 *    onUnstick: null
 *  });
 */

;(function($, window, document, undefined) {

  var Stickem = function(elem, options) {
    this.elem = elem;
    this.$elem = $(elem);
    this.options = options;
    this.metadata = this.$elem.data("stickem-options");
    this.$win = $(window);
  };

  Stickem.prototype = {
    defaults: {
      item: '.stickem',
      container: '.stickem-container',
      stickClass: 'stickit',
      endStickClass: 'stickit-end',
      offset: 0,
      start: 0,
      onStick: null,
      onUnstick: null
    },

    init: function() {
      var _self = this;

      //Merge options
      _self.config = $.extend({}, _self.defaults, _self.options, _self.metadata);

      _self.setWindowHeight();
      _self.getItems();
      _self.bindEvents();

      return _self;
    },

    bindEvents: function() {
      var _self = this;

      _self.$win.on('scroll.stickem', $.proxy(_self.handleScroll, _self));
      _self.$win.on('resize.stickem', $.proxy(_self.handleResize, _self));
    },

    destroy: function() {
      var _self = this;

      _self.$win.off('scroll.stickem');
      _self.$win.off('resize.stickem');
    },

    getItem: function(index, element) {
      var _self = this;
      var $this = $(element);
      var item = {
        $elem: $this,
        elemHeight: $this.height(),
        $container: $this.parents(_self.config.container),
        isStuck: false
      };

      //If the element is smaller than the window
      if(_self.windowHeight > item.elemHeight) {
        item.containerHeight = item.$container.outerHeight();
        item.containerInner = {
          border: {
            bottom: parseInt(item.$container.css('border-bottom'), 10) || 0,
            top: parseInt(item.$container.css('border-top'), 10) || 0
          },
          padding: {
            bottom: parseInt(item.$container.css('padding-bottom'), 10) || 0,
            top: parseInt(item.$container.css('padding-top'), 10) || 0
          }
        };

        item.containerInnerHeight = item.$container.height();
        item.containerStart = item.$container.offset().top - _self.config.offset + _self.config.start + item.containerInner.padding.top + item.containerInner.border.top;
        item.scrollFinish = item.containerStart - _self.config.start + (item.containerInnerHeight - item.elemHeight);

        //If the element is smaller than the container
        if(item.containerInnerHeight > item.elemHeight) {
          _self.items.push(item);
        }
      } else {
        item.$elem.removeClass(_self.config.stickClass + ' ' + _self.config.endStickClass);
      }
    },

    getItems: function() {
      var _self = this;

      _self.items = [];

      _self.$elem.find(_self.config.item).each($.proxy(_self.getItem, _self));
    },

    handleResize: function() {
      var _self = this;

      _self.getItems();
      _self.setWindowHeight();
    },

    handleScroll: function() {
      var _self = this;

      if(_self.items.length > 0) {
        var pos = _self.$win.scrollTop();

        for(var i = 0, len = _self.items.length; i < len; i++) {
          var item = _self.items[i];

          //If it's stuck, and we need to unstick it, or if the page loads below it
          if((item.isStuck && (pos < item.containerStart || pos > item.scrollFinish)) || pos > item.scrollFinish) {
            item.$elem.removeClass(_self.config.stickClass);

            //only at the bottom
            if(pos > item.scrollFinish) {
              item.$elem.addClass(_self.config.endStickClass);
            }

            item.isStuck = false;

            //if supplied fire the onUnstick callback
            if(_self.config.onUnstick) {
              _self.config.onUnstick(item);
            }

          //If we need to stick it
          } else if(item.isStuck === false && pos > item.containerStart && pos < item.scrollFinish) {
              item.$elem.removeClass(_self.config.endStickClass).addClass(_self.config.stickClass);
              item.isStuck = true;

              //if supplied fire the onStick callback
              if(_self.config.onStick) {
                _self.config.onStick(item);
              }
          }
        }
      }
    },

    setWindowHeight: function() {
      var _self = this;

      _self.windowHeight = _self.$win.height() - _self.config.offset;
    }
  };

  Stickem.defaults = Stickem.prototype.defaults;

  $.fn.stickem = function(options) {
    //Create a destroy method so that you can kill it and call it again.
    this.destroy = function() {
      this.each(function() {
        new Stickem(this, options).destroy();
      });
    };

    return this.each(function() {
      new Stickem(this, options).init();
    });
  };

})(jQuery, window , document);
}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/admin/source/js/app/lib/vendor/jquery.stickem.js","/admin/source/js/app/lib/vendor")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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